import { h, t as translate, d, p as p$1, E } from './built-constants-439d5572.js';
import { p } from './built-clsx.m-cb13ff27.js';
import { P as ProductTile, i as initDyRecommendations } from './built-init-1bb12f92.js';
import { i as initSlickCarousels, d as destroySlickCarousels } from './built-slick-carousel-807ba140.js';

/**
 * @typedef ProductTileCarouselProps
 * @property {ProductTile[]} productTiles
 * @property {ProductTileRenderOptions} renderOpts
 * @property {DynamicYieldWidgetTracking} dyWidgetTracking
 * @property {string} [widgetTitle=''] The widget heading/title
 */

/**
 * @param {ProductTileCarouselProps} props
 */

const ProductTileCarousel = ({
  productTiles,
  renderOpts,
  dyWidgetTracking,
  widgetTitle = ''
}) => {
  // Handle init/destory of Slick carousels
  p(() => {
    initSlickCarousels();
    return () => destroySlickCarousels();
  }, []); // The 3rd-party libraries need reference to the carousel container element

  const carouselContainerElRef = p$1();
  p(() => {
    var _window$DYO, _window$DYO$recommend;

    // The container element needs to be registered for Dynamic Yield tracking
    (_window$DYO = window.DYO) == null ? void 0 : (_window$DYO$recommend = _window$DYO.recommendations) == null ? void 0 : _window$DYO$recommend.registerElements(carouselContainerElRef.current);
  }, [carouselContainerElRef]);
  return h(d, null, widgetTitle !== '' && h("div", {
    class: "de-u-padBottom1"
  }, h("h2", {
    class: "de-u-borderBottomLg de-u-borderLime de-u-textGrow2 de-u-md-textGrow3 de-u-lg-textGrow4 de-u-spaceBottomNone de-u-inline"
  }, widgetTitle)), h("div", {
    class: "de-ProductTileCarousel js-de-SlickProductTileCarousel",
    "aria-roledescription": translate("Carousel"),
    "aria-label": translate("Colección de productos") // @todo Is there a better way to set this button up? This feels, awkward.
    ,
    "data-arrow-next-button": "<button\n          aria-label=\"" + translate("Desplácese a productos siguientes") + "\"\n          class=\"de-ProductTileCarousel-button slick-next\"\n        >\n          <svg\n            class=\"de-ProductTileCarousel-svg\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"20\"\n            height=\"20\"\n            viewBox=\"0 0 20 20\"\n          >\n            {/* @todo Use translation keys */}\n            <title>Scroll to left set of products</title>\n            <path d=\"M19.71,9.23,13.56,2.31a1.19,1.19,0,0,0-1.64-.11,1.19,1.19,0,0,0-.08,1.65l4.45,5H1.15a1.15,1.15,0,1,0,0,2.3H16.29l-4.45,5a1.18,1.18,0,0,0,.09,1.64,1.15,1.15,0,0,0,1.63-.1l6.15-6.92A1.17,1.17,0,0,0,19.71,9.23Z\" />\n          </svg>\n        </button>" // @todo Is there a better way to set this button up? This feels, awkward.
    ,
    "data-arrow-previous-button": "<button\n          aria-label=\"" + translate("Desplácese a productos anteriores") + "\"\n          class=\"de-ProductTileCarousel-button slick-prev\"\n        >\n          <svg\n            class=\"de-ProductTileCarousel-svg\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"20\"\n            height=\"20\"\n            viewBox=\"0 0 20 20\"\n          >\n            {/* @todo Use translation keys */}\n            <title>Scroll to right set of products</title>\n            <path d=\"M19.71,9.23,13.56,2.31a1.19,1.19,0,0,0-1.64-.11,1.19,1.19,0,0,0-.08,1.65l4.45,5H1.15a1.15,1.15,0,1,0,0,2.3H16.29l-4.45,5a1.18,1.18,0,0,0,.09,1.64,1.15,1.15,0,0,0,1.63-.1l6.15-6.92A1.17,1.17,0,0,0,19.71,9.23Z\" />\n          </svg>\n        </button>" // Dynamic Yield tracking data
    // @see https://support.dynamicyield.com/hc/en-us/articles/360022557954-Recommendations-Client-Side-APIs?flash_digest=9d5d53e6eb9dafa553e4645f42741999ba126f03#track-recommendation-widget-0-5
    ,
    "data-dy-widget-id": dyWidgetTracking.widgetId,
    "data-dy-feed-id": dyWidgetTracking.feedId,
    ref: carouselContainerElRef // @todo This seems backwards of what's expected
    ,
    "data-is-full-width": "false"
  }, productTiles.map(productTile => h(ProductTile, {
    productTileClass: "de-ProductTileCarousel-item de-u-padEnds de-u-md-padEndsNone",
    key: productTile.id,
    productTile: productTile,
    renderOpts: renderOpts
  }))));
};

// @ts-check
/**
 * Initializes a Dynamic Yield driven Product Tile carousel
 *
 * Used as import by other modules to init DY product tile carousel without the
 * need of an extra built entry file if not needed.
 *
 * @param {string} containerElSelector The widget container CSS selector
 */

const init = containerElSelector => {
  initDyRecommendations({
    containerElSelector,
    targetElSelector: '.js-de-DYProductTileCarousel-Target',
    onDataReady: ({
      productTiles,
      renderOpts,
      containerEl,
      targetEl,
      dyWidgetTracking,
      widgetTitle
    }) => {
      E(h(ProductTileCarousel, {
        widgetTitle: widgetTitle,
        productTiles: productTiles,
        renderOpts: renderOpts,
        dyWidgetTracking: dyWidgetTracking
      }), containerEl, targetEl);
    }
  });
};

export { init as i };
